import { twSort } from 'atp-react-ui';

const useStyles = () => ({
  options: twSort`font-ibm-plex-sans cursor-pointer rounded-lg bg-white p-4 text-base font-normal leading-4 text-secondary-dark shadow-card-primary-x-light md:text-lg lg:rounded-xl lg:px-6 lg:py-3.5 lg:leading-6`,
  active: twSort`font-ibm-plex-sans rounded-br-none bg-primary text-base font-normal leading-4 text-white shadow-card-primary-x-light md:text-lg lg:rounded-2xl lg:rounded-br-none lg:leading-6`,
});

export default useStyles;
